import { CompanySelection } from '../../../../../shared/components/custom/CompanyDimensionPicker/types'
import { CustomReportArgument } from '../../../../../redux/context/customReports/types'
import { Company } from '../../../../../types/company/Company'

export const mergeArgumentsToPickerValue = (
  companyArg: CustomReportArgument | undefined,
  dimensionArg: CustomReportArgument | undefined,
  companies: Company[]
): CompanySelection[] => {
  const selectionMap = new Map<string, CompanySelection>()

  companyArg?.values.forEach(v => {
    if ('id' in v && v.id) {
      const id = String(v.id)
      selectionMap.set(id, {
        id,
        name: companies.find(c => c.id === id)?.name ?? ''
      })
    }
  })

  dimensionArg?.values.forEach(v => {
    if ('companyId' in v && 'dimensionId' in v) {
      const cId = v.companyId as string
      const dId = v.dimensionId as string
      const existing = selectionMap.get(cId)
      if (existing) {
        existing.dimensions = [...(existing.dimensions ?? []), dId]
      } else {
        selectionMap.set(cId, {
          id: cId,
          name: companies.find(c => c.id === cId)?.name ?? '',
          dimensions: [dId]
        })
      }
    }
  })

  return Array.from(selectionMap.values())
}

export const splitPickerToCompanyArgValues = (selections: CompanySelection[]): { id: string }[] =>
  selections.map(s => ({ id: s.id }))

export const splitPickerToDimensionArgValues = (
  selections: CompanySelection[]
): { companyId: string; dimensionId: string }[] =>
  selections.flatMap(s => (s.dimensions ?? []).map(dimId => ({ companyId: s.id, dimensionId: dimId })))
